<template>
<div class="message-editor">
    <Loader :loading="loading"></Loader>

    <div class="message-editor-buttons">

        <span @click="$emit('close')" class="close">
            <i class="icon icon-close"></i>
        </span>

		To: Kolkin

        <div class="message-editor-right">
            <span @click="uploadFile" title="Attach file">
                <i class="icon icon-attach"></i>
            </span>

            <span @click="sendMessage" class="send">
                <i class="icon icon-chevron-right"></i>
            </span>
        </div>

    </div>

    <TicketMessageTiptap ref="tiptap" @selected="fileSelected" @renamed="fileRenamed"></TicketMessageTiptap>



</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import TicketMessageTiptap from "@/components/support/TicketMessageTiptap";
import Loader from "@/../submodules/vue-base/components/Loader";
import AvatarText from "@/mixins/AvatarText";

export default {

    name: "SendMessageMenu",

    components: {
        TicketMessageTiptap,
        Loader
    },

    mixins: [
        AvatarText
    ],

    data() {
        return {
            listOfFiles: [],
            loading: false,
        };
    },

    methods: {
        fileSelected(fileObject) {
            this.listOfFiles.push(fileObject)
        },

        fileRenamed(renameObject) {
            for (var i = 0; i < this.listOfFiles.length; i++) {
                if (this.listOfFiles[i].uuid == renameObject.uuid) {
                    //you have to remake a file object to remake it
                    const newFile = new File([this.listOfFiles[i].file], renameObject.linkText, {
                        type: this.listOfFiles[i].file.type
                    });
                    this.listOfFiles[i].file = newFile;
                }
            }
        },

        checkUploads() {
            var uploadsArray = this.$refs.tiptap.scanForUploads();
            for (var i = 0; i < this.listOfFiles.length; i++) {
                var foundIndex = uploadsArray.indexOf(this.listOfFiles[i].file.name)
                if (foundIndex == -1) {
                    this.listOfFiles.splice(i, 1);
                    i--;
                } else {
                    uploadsArray.splice(foundIndex, 1);
                }
            }
        },
        uploadFile() {
            this.$refs.tiptap.openGenericModal();
        },

        sendMessage() {
            if (this.supportTicket.is_resolved == 't') {
                return;
            }

            var params = {
                offset: 0,
                limit: 20,
                id: this.$route.params.id
            }

            this.checkUploads();

            var html = this.$refs.tiptap.editor.getHTML();
            var text = this.$refs.tiptap.getBody();
            var json = this.$refs.tiptap.editor.getJSON();
            text = text.trim();
            if (!text && html == "<p></p>") {
                return;
            }

            var obj = {
                json: json,
                support_ticket_id: this.supportTicket.ticket_id
            };

            var formData = new FormData();
            formData.append("message_json", JSON.stringify(obj));
            for (var i = 0; i < this.listOfFiles.length; i++) {
                formData.append("filename", this.listOfFiles[i].file.name);
                formData.append("file", this.listOfFiles[i].file);
            }
            var temp = this;
            this.$store.dispatch("sendTicketMessage", formData).then(function () {
                temp.$store.dispatch("loadTicketMessages", params).then(function () {
                    temp.listOfFiles = [];
                    temp.$refs.tiptap.clear();
                })
            });
        },
    },

    computed: {
        ...mapGetters(["user", "supportTicket"])
    },
}
</script>
